import React from "react";

// Frame art is pure CSS (see .tc-frame-* in index.css). No external image assets.
const initials = (name = "") => name.trim().split(/\s+/).slice(0, 2).map((w) => w[0]?.toUpperCase() || "").join("") || "?";

export const FrameAvatar = ({ name, frame, size = 44, testid }) => (
  <span data-testid={testid} data-frame={frame || "none"} title={frame ? "Profile frame" : undefined}
    className={`tc-frame ${frame ? `tc-frame-${frame}` : "tc-frame-none"}`} style={{ width: size, height: size }}>
    <span className="tc-frame-inner font-heading font-bold" style={{ fontSize: Math.round(size * 0.36) }}>{initials(name)}</span>
  </span>
);
